export default __webpack_public_path__ + "static/media/braille-16.e669f500.svg";